const css = `.survey-results {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.survey-results .survey-results-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.survey-results .survey-results-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.survey-results .survey-results-round-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  min-width: 0;
}
.survey-results .survey-results-round {
  width: 148px;
  border-radius: 12px;
}
.survey-results .survey-results-round-meta {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.survey-results .survey-results-view-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.survey-results .survey-results-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.survey-results .survey-results-overview {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) minmax(0, 3fr);
  gap: 16px;
}
@media (max-width: 900px) {
  .survey-results .survey-results-overview {
    grid-template-columns: minmax(0, 1fr);
  }
}
.survey-results .survey-results-count {
  justify-content: space-between;
}
.survey-results .survey-results-count-value {
  font-size: var(--font-size-5xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-none);
}
.survey-results .survey-question-answers header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.survey-results .survey-question-answers .survey-question-answers-header {
  position: relative;
  flex: 1;
  gap: 12px;
  min-width: 0;
  cursor: pointer;
}
.survey-results .survey-question-answers .survey-question-answers-header h3 {
  flex: 1;
  min-width: 0;
  margin: 4px 0 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  overflow-wrap: anywhere;
}
.survey-results .survey-question-answers .survey-question-answers-fold {
  flex-shrink: 0;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  cursor: pointer;
}
.survey-results .survey-question-answers .survey-question-answers-fold::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
}
.survey-results .survey-question-answers .survey-question-answers-fold:focus-visible {
  outline: none;
}
.survey-results .survey-question-answers .survey-question-answers-fold:focus-visible::after {
  outline: 2px solid var(--ring);
  outline-offset: 4px;
}
.survey-results .survey-question-answers .survey-question-answers-fold .pi {
  font-size: var(--font-size-xs);
}
.survey-results .survey-question-answers .survey-question-answers-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 600px) {
  .survey-results .survey-question-answers .survey-question-answers-header {
    flex-wrap: wrap;
  }
  .survey-results .survey-question-answers .survey-question-answers-header .survey-question-answers-title {
    flex-basis: calc(100% - 80px);
  }
  .survey-results .survey-question-answers .survey-question-answers-count {
    order: 3;
    margin-left: 48px;
  }
  .survey-results .survey-question-answers ul {
    columns: 1;
  }
}
.survey-results .survey-question-answers li > button {
  display: -webkit-box;
  width: 100%;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  line-height: inherit;
  text-align: left;
  white-space: pre-line;
  overflow: hidden;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.survey-results .survey-question-answers li.is-expanded > button {
  display: block;
}
.survey-results .survey-question-answers ul {
  columns: 3 260px;
  column-gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.survey-results .survey-question-answers li {
  position: relative;
  margin-bottom: 12px;
  break-inside: avoid;
  padding: 12px 16px 12px 16px;
  border-radius: 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.survey-results .survey-question-answers li::before {
  content: "";
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--accent-chip-border);
}
.survey-results .survey-question-answers-badge {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background-color: var(--accent-chip);
  border: 1px solid var(--accent-chip-border);
  color: var(--accent-hover);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
}
.survey-results .survey-question-answers-count {
  flex-shrink: 0;
  margin-top: 8px;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.survey-results .survey-question-answers-toggle.p-button {
  align-self: flex-start;
  padding: 0;
}
.survey-results .survey-responses thead th {
  vertical-align: top;
}
@media screen and (max-width: 768px) {
  .survey-results .survey-responses tbody td > .cell-header {
    flex: 0 0 40%;
    overflow-wrap: anywhere;
  }
  .survey-results .survey-responses tbody td > .string-value {
    display: block;
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    contain: inline-size;
  }
}
.survey-results .survey-responses td.string::after {
  content: none;
}
.survey-results .survey-responses .string-value {
  contain: none;
  display: -webkit-box;
  max-width: 340px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow-wrap: anywhere;
}
.survey-results .survey-responses th .header-label-container span {
  display: -webkit-box;
  max-width: 340px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.survey-results .survey-responses tbody tr {
  cursor: pointer;
}

.survey-results-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  border-radius: 16px;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  min-width: 0;
}

.survey-results-card-label {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
}

.survey-results-card-hint {
  margin: 0;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.survey-rating-summary {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 24px;
}
.survey-rating-summary .survey-rating-summary-score {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  min-width: 140px;
}
.survey-rating-summary .survey-rating-summary-value {
  font-size: var(--font-size-5xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-none);
}
.survey-rating-summary .survey-rating-summary-value small {
  margin-left: 4px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-subtle);
}
.survey-rating-summary .survey-rating-summary-chart {
  flex: 1;
  min-width: 260px;
}

.survey-rating-bars {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 8px;
  height: 140px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.survey-rating-bars li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.survey-rating-bars .survey-rating-bar-count {
  height: 16px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
}
.survey-rating-bars .survey-rating-bar-track {
  display: flex;
  flex: 1;
  align-items: flex-end;
  width: 100%;
  border-radius: 6px;
  background: var(--surface-sunken);
  overflow: hidden;
}
.survey-rating-bars .survey-rating-bar {
  width: 100%;
  min-height: 0;
  border-radius: 6px;
  transition: height 0.3s ease;
}
.survey-rating-bars .survey-rating-bar-label {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.tone-low {
  --tone: var(--rating-low);
}

.tone-mid {
  --tone: var(--rating-mid);
}

.tone-high {
  --tone: var(--rating-high);
}

.survey-rating-bar[class*=tone-] {
  background: var(--tone);
}

.survey-rating-summary-value[class*=tone-]::before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 12px;
  border-radius: 50%;
  background: var(--tone);
  vertical-align: middle;
}

.survey-results-round-panel.p-dropdown-panel {
  min-width: 220px;
}

.survey-locale-chip {
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  border-radius: 6px;
  background-color: var(--neutral-chip);
  border: 1px solid var(--neutral-chip-border);
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  line-height: 16px;
  letter-spacing: var(--letter-spacing-wide);
  vertical-align: 1px;
}

.survey-question-answers li .survey-locale-chip {
  margin-right: var(--space-1);
}

.survey-question-answers-title {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.survey-question-answers-language {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
  overflow-wrap: anywhere;
}

.survey-round-option {
  white-space: nowrap;
}

.survey-round-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.survey-round-item .survey-round-item-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.survey-round-item .survey-round-item-period {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.survey-results-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  border-radius: 16px;
  border: 1.5px dashed var(--border);
  text-align: center;
}
.survey-results-empty.is-inline {
  padding: 32px 24px;
}
.survey-results-empty > .pi {
  font-size: var(--font-size-3xl);
  color: var(--text-subtle);
}
.survey-results-empty h2 {
  margin: 0;
  font-size: var(--font-size-lg);
}
.survey-results-empty p {
  max-width: 420px;
  margin: 0;
  color: var(--text-muted);
}

.survey-response-panel .survey-response-detail {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0;
}
.survey-response-panel .survey-response-detail dt {
  margin-bottom: 8px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--text-muted);
  overflow-wrap: anywhere;
}
.survey-response-panel .survey-response-detail dd {
  margin: 0;
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.survey-response-panel .survey-response-detail dd.is-empty {
  color: var(--text-subtle);
  font-style: italic;
}
.survey-response-panel .survey-response-detail .survey-response-rating {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
}

.survey-round-trend header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.survey-round-trend header h2,
.survey-round-trend header p {
  margin: 0;
  font-size: var(--font-size-sm);
}
.survey-round-trend ol {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.survey-round-trend-row {
  display: grid;
  grid-template-columns: minmax(150px, 1.2fr) minmax(80px, 2fr) 44px 52px minmax(120px, 1.2fr);
  grid-template-areas: "round bar average delta meta";
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.survey-round-trend-row:hover {
  background: var(--surface);
}
.survey-round-trend-row:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.survey-round-trend-row.is-selected {
  background: var(--surface);
  border-color: var(--border);
}
.survey-round-trend-row.is-low-sample .survey-round-trend-bar,
.survey-round-trend-row.is-low-sample .survey-round-trend-average {
  opacity: 0.5;
}
@media (max-width: 600px) {
  .survey-round-trend-row {
    grid-template-columns: minmax(0, 1fr) 44px 52px;
    grid-template-areas: "round average delta" "bar bar bar" "meta meta meta";
    row-gap: 8px;
  }
}

.survey-round-trend-round {
  grid-area: round;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.survey-round-trend-round span {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.survey-round-trend-bar-track {
  grid-area: bar;
  height: 8px;
  border-radius: 4px;
  background: var(--surface-sunken);
  overflow: hidden;
}

.survey-round-trend-bar {
  display: block;
  height: 100%;
  border-radius: 4px;
  background: var(--tone);
}

.survey-round-trend-average {
  grid-area: average;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  text-align: right;
}

.survey-round-trend-delta {
  grid-area: delta;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  text-align: right;
}
.survey-round-trend-delta.is-up {
  color: var(--success);
}
.survey-round-trend-delta.is-down {
  color: var(--danger);
}
.survey-round-trend-delta.is-flat {
  color: var(--text-muted);
}

.survey-round-trend-meta {
  grid-area: meta;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.survey-round-trend-warning {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--warning);
  font-weight: var(--font-weight-semibold);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
